<template>
  <div>
    <page-nav-bar
      :is-sticky="true"
      :back-button="true"
      :title="'Création d\'un Tiers'">
    </page-nav-bar>
    <page-content
      :has-no-padd-on-act-on-desktop="false"
      :set-main-col-class="'is-12 is-9-widescreen is-8-fullhd'">
      <div class="has-background-white is-border">
        <tiers-form
          :source-loading="loading"
          :new-tiers="true"
          @submit="createTiers"></tiers-form>
      </div>
    </page-content>
  </div>
</template>

<script>
import TiersMixin from './TiersMixin'

export default {
  name: 'TiersCreate',
  components: {
    TiersForm: () => import('@/components/tiers/TiersForm')
  },
  mixins: [TiersMixin]
}
</script>
